module.exports = __webpack_public_path__ + "img/WaterGuru-Logo.0d855848.svg";